import React, { useEffect, useRef, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    let current = 0;
    const cycle = () => {
      setIndex(current % purchaseNotifications.length);
      setVisible(true);
      current += 1;
      timers.current.push(window.setTimeout(() => {
        setVisible(false);
        timers.current.push(window.setTimeout(cycle, 9000));
      }, 5500));
    };
    timers.current.push(window.setTimeout(cycle, 6000));
    const snapshot = timers.current;
    return () => snapshot.forEach(t => window.clearTimeout(t));
  }, []);
  const item = purchaseNotifications[index];
  return <AnimatePresence data-id="element-36" data-mp="1gxvwaw4lzx7u">
      {visible && <motion.div initial={{
      x: -24,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -24,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 z-30 max-w-[280px] rounded-2xl border border-brand-500/30 bg-ink-800/95 p-3 shadow-2xl backdrop-blur-md sm:max-w-xs" role="status" aria-live="polite" data-id="element-37" data-mp="165zfcbe2tlnx">
          <div className="flex items-start gap-2.5" data-id="element-38" data-mp="n86av4nt13of">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-400" aria-hidden="true" data-id="element-39" data-mp="n8y6gfhej1ep" />
            <div data-id="element-40" data-mp="iaeh053ln7hl">
              <p className="text-[13px] font-bold leading-snug text-white" data-id="element-41" data-mp="x5153bd1ohww">{item.name}</p>
              <p className="text-[12px] leading-snug text-white/60" data-id="element-42" data-mp="s67wnxcm7h3l">
                ha appena acquistato il Sistema Anti-Rifiniture™
              </p>
              <p className="mt-1 text-[11px] font-medium text-brand-400" data-id="element-43" data-mp="28iwm6pnif0qr">
                {item.place} · pochi minuti fa
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}